// src/chains/optimism.js - Optimism Mainnet configuration
import { createChainConfig } from './chainConfig';

export const optimismConfig = createChainConfig({
  key: 'optimism',
  chainId: 10,
  name: 'Optimism Mainnet',
  rpcUrl: 'https://1rpc.io/op',
  explorerUrl: 'https://optimistic.etherscan.io',
  
  // Native token information (uses ETH but on Optimism network)
  nativeTokenSymbol: 'ETH',
  nativeTokenName: 'Ethereum',
  nativeTokenIcon: 'https://i.imgur.com/0ZOPyLn.png', // Same ETH icon
  nativeTokenDecimals: 18,
  
  // Related token addresses
  wrappedNativeToken: '0x4200000000000000000000000000000000000006', // WETH on Optimism
  
  // Price and API endpoints
  coingeckoAPI: 'https://api.coingecko.com/api/v3/simple/price?ids=ethereum&vs_currencies=usd&include_24hr_change=true',
  coingeckoId: 'ethereum',
  geckoTerminalId: 'optimism',
  tokenListUrl: 'https://raw.githubusercontent.com/sushiswap/list/master/lists/token-lists/default-token-list/tokens/optimism.json',
  
  // SushiSwap configuration
  aggregatorAddress: 'SushiSwap',
  sushiswapConfig: {
    apiBaseUrl: 'https://api.sushi.com',
    routerAddress: '0xAC4c6e212A361c968F1725b4d055b47E63F80b75' // Optimism SushiSwap router
  },
  
  // Legacy aggregator reference (e.g., Uniswap)
  legacyAggregatorAddress: '0x68b3465833fb72A70ecDF485E0e4C7bD8665Fc45', // Uniswap V3 router
  
  // Transaction support
  supportsEIP1559: true,
  
  // Transaction history API
  txHistoryApi: 'https://api.routescan.io/v2/network/mainnet/evm/10/address/{address}/transactions',
});